import { render, staticRenderFns } from "./chatIndex.vue?vue&type=template&id=df0110d2&scoped=true&"
import script from "./chatIndex.vue?vue&type=script&lang=js&"
export * from "./chatIndex.vue?vue&type=script&lang=js&"
import style0 from "./chatIndex.vue?vue&type=style&index=0&id=df0110d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0110d2",
  null
  
)

export default component.exports